import React from 'react';

const AdjustableTextarea = ({ value = '', onChange, disabled, className = '', style = {}, placeholder }) => {
    return (
        <textarea
            value={value}
            onChange={onChange}
            disabled={disabled}
            className={className}
            placeholder={placeholder}
            style={{
                width: '100%',
                minWidth: 0,
                minHeight: 100,
                maxHeight: 400,
                resize: 'vertical',
                padding: '10px 12px',
                border: '1px solid #d5deea',
                borderRadius: 8,
                boxSizing: 'border-box',
                color: '#1f2a3d',
                fontSize: 14,
                lineHeight: 1.45,
                outline: 'none',
                ...style,
            }}
        />
    );
};

export default AdjustableTextarea;
